import React from 'react';
import ManagerHeader from "../components/_layout/ManagerHeader";

const PlaceholderLayout: React.FC<{ children: React.ReactNode }> = ({children}) => {
    return (
        <div className='bg-melon-light flex flex-col h-screen overflow-hidden font-medium text-melon-black font-acrom'>
            <div className='flex-1 flex px-16 mb-5 overflow-hidden'>
                {children}
            </div>
        </div>
    );
};

export default PlaceholderLayout;